import momentTimezone from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min';

const moment = require('moment');
require('moment/locale/de');
require('moment/locale/de-at');
require('moment/locale/de-ch');
require('moment/locale/en-gb');
require('moment/locale/fr');
require('moment/locale/nl');
require('moment/locale/it');
require('moment/locale/es');

moment.locale('de');
// moment.tz.setDefault('Europe/Vienna');

/*
 setting users local time zone instead (in src/lib/util/moment.js), because otherwise we might be getting dates a full day off
 example:
 * 20211023 is set as arrivalDate
 * moment default timezone is set to Europe/Vienna
 * date object created is 23.10.2021 00:00:00 GMT+0200 CEST
 * when being formatted with Intl.DateTimeFormat the browser is using the system timezone (e.g. Atlantic/Canary)
 * therefore the output date object is 22.10.2021 23:00:00 GMT+0100 WEST
 * the resulting date is 22.10.2021
*/
moment.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone);

export default moment;



// WEBPACK FOOTER //
// ./src/lib/util/moment.js